export const WHATSAPP_URL = "https://wa.me/5521967050506";
export const INSTAGRAM_URL = "https://www.instagram.com/marianecprado/";
export const THREADS_URL = "https://www.threads.com/@marianecprado";
export const GOOGLE_URL = "https://share.google/sDghvkMlcMgvPKJEB";

export const goTo = (hash) => (e) => {
  if (e) e.preventDefault();
  const lenis = typeof window !== "undefined" ? window.__lenis : null;
  if (lenis) {
    lenis.scrollTo(hash === "#top" ? 0 : hash, { offset: hash === "#top" ? 0 : -76, duration: 1.4 });
  } else if (hash === "#top") {
    window.scrollTo({ top: 0, behavior: "smooth" });
  } else {
    document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" });
  }
};
